export default __webpack_public_path__ + "static/media/paul.7ff0a1b8.jpg";